import PropTypes from 'prop-types'
import React from 'react'
import {
  Carousel, Container, Row,
  Col, Card,
} from 'react-bootstrap'
import { Button, Breadcrumb } from 'antd'
import {
  PlayCircleTwoTone, GlobalOutlined, ShoppingOutlined,
  PhoneOutlined, ReadOutlined, CalendarOutlined,
  InfoCircleOutlined, FolderOpenOutlined,
} from '@ant-design/icons'
import { InfoCard, ArticleCard } from 'components/elements'

const LearnSiplah = () => (
  <div className="h-100">

    {/*= ========= breadcrumb section ========== */}
    <section className="py-4 bg-pearl-blue">
      <Container className="section-header">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/">Home</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Pelajari SIPLah</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
    </section>

    {/*= ========= info section ========== */}
    <section className="py-5">
      <Container>
        <div className="text-center" />
        <Row>
          <Col xs={12} lg={3} className="mb-3 mb-lg-0">
            <InfoCard
              icon={<ReadOutlined />}
              title="Informasi Terkini"
              shortDescription="Cari tahu tentang Kegiatan/Pengumuman/Berita Terkini."
            />
          </Col>
          <Col xs={12} lg={3} className="mb-3 mb-lg-0">
            <InfoCard
              icon={<ShoppingOutlined />}
              title="Mitra SIPLah"
              shortDescription="Untuk berbelanja silahkan kunjungi Mitra SIPLah."
            />
          </Col>
          <Col xs={12} lg={3} className="mb-3 mb-lg-0">
            <InfoCard
              icon={<PhoneOutlined />}
              title="Hubungi SIPLah"
              shortDescription="Untuk meningkatkan pelayanan mohon menghubungi pusat layanan yang telah disediakan."
            />
          </Col>
          <Col xs={12} lg={3} className="mb-3 mb-lg-0">
            <InfoCard
              icon={<GlobalOutlined />}
              title="Social Media SIPLah"
              shortDescription="Subscribe dan ikuti media sosial SIPLah untuk mendapatkan informasi terkini."
            />
          </Col>
        </Row>
      </Container>
    </section>

    {/*= ========= article info section ========== */}
    <section className="py-5 bg-pearl-blue">
      <Container className="section-header">
        <div className="title-wrapper text-center mb-5">
          <h2>TENTANG SIPLAH</h2>
          <h3>
            Cari tahu informasi
            <span>SIPLah</span>
          </h3>
          <p>Deskripsi tentang siplah</p>
        </div>
        <Row>
          <Col lg={12} className="mb-5">
            <ArticleCard
              thumbnailImg="./assets/article-info-1.jpeg"
              title="Sosialisasi Surat Edaran (SE) Mendikbud Nomor 8 Tahun 2020 dengan tema Sinergi Kebijakan Pengadaan Barang dan Jasa Satuan Pendidikan"
              url="https://siplah.kemendikdasmen.go.id/index.php/tentang_siplah/entry/sinergi-kebijakan-pengadaan-barang-dan-jasa-satuan-pendidikan"
              date="10 Nov 2020"
              shortDescription={(
                <React.Fragment>
                  <p>SIPLah adalah inovasi dalam pengadaan barang/jasa Satuan Pendidikan untuk meningkatkan transparansi dan kemudahan bagi Satuan Pendidikan (Satdik) dalam administrasi dan pelaporan serta bagi UMKM untuk turut serta hadir sebagai penyedia barang dan jasa di SIPLah.</p>
                  <p>Guna mendukung implementasinya, Kemendikbud menerbitkan Surat Edaran Nomor 8 Tahun 2020 tentang Pelaksanaan Pengadaan Barang dan Jasa Satuan Pendidikan melalui Sistem Informasi Pengadaan di Sekolah (SIPLah), informasi tersebut sangat penting bagi para pemangku kebijakan, terutama Pemerintah Daerah, Satuan Pendidikan serta bagi UMKM. </p>
                </React.Fragment>
                )}
            />
          </Col>
          <Col lg={12} className="mb-5">
            <ArticleCard
              thumbnailImg="./assets/article-info-2.png"
              title="Modul Panduan Penggunaan SIPLah"
              url="https://siplah.kemendikdasmen.go.id/index.php/tentang_siplah/entry/modul-panduan-penggunaan-siplah"
              date="22 Oct 2020"
              shortDescription={(
                <React.Fragment>
                  <p>Berisi modul panduan penggunaan SIPLah yang dapat diakses bagi:</p>
                  <p>
                    <b>Satuan Pendidikan</b>
                    <br />
                    - Tutorial bagi pembeli (cara belanja melalui SIPLah)
                  </p>
                  <p>
                    <b>Penyedia barang/jasa</b>
                    <br />
                    - Tutorial bagi penjual (cara mendaftar menjadi penyedia barang/jasa di SIPLah)
                  </p>
                </React.Fragment>
                )}
            />
          </Col>
        </Row>
      </Container>
    </section>

    {/*= ========= mitra section ========== */}
    <section className="py-5">
      <Container className="section-header">
        <div className="title-wrapper text-center mb-5">
          <h2>REGULASI SIPLAH</h2>
          <h3>
            Cari tahu Regulasi
            <span>SIPLah</span>
          </h3>
          <p>Regulasi Description</p>
        </div>
        <ul className="pl-0 pl-lg-3 news-wrapper">
          <li className="d-flex">
            <FolderOpenOutlined />
            <div className="ml-2 text-justify">
              <h5>PERMENDIKBUD NOMOR 14 TAHUN 2020 TENTANG PEDOMAN PENGADAAN BARANG DAN JASA OLEH SATUAN PENDIDIKAN</h5>
              <p>
                Permendikbud Nomor 14 Tahun 2020 Tentang Pedoman Pengadaan Barang/Jasa oleh Satuan Pendidikan merupakan acuan bagi Satuan Pendidikan dalam:
                <br />
                a. melaksanakan PBJ Satuan Pendidikan secara efektif, efisien, transparan, dan akuntabel;
                <br />
                b. memperoleh barang/jasa yang tepat dari setiap dana yang dibelanjakan oleh Satuan Pendidikan diukur dari aspek kualitas, kuantitas, waktu, dan lokasi.
              </p>
            </div>
          </li>
        </ul>
      </Container>
    </section>

    {/*= ========= article linimasa section ========== */}
    <section className="py-5 bg-pearl-blue">
      <Container className="section-header">
        <div className="title-wrapper text-center mb-5">
          <h2>LINIMASA SIPLAH</h2>
          <h3>
            Cari tahu linimasa
            <span>SIPLah</span>
          </h3>
          <p>Linimasa</p>
        </div>
        <Row>
          <Col lg={12} className="mb-5">
            <ArticleCard
              thumbnailImg="./assets/article-1.jpeg"
              title="Kemendikbud Raih Penghargaan Indonesia Government Procurement Awards dari LKPP"
              url="https://siplah.kemendikdasmen.go.id/index.php/linimasa/entry/kemendikbud-raih-penghargaan-indonesia-government-procurement-awards-dari-lkpp"
              date="19 Nov 2020"
              shortDescription={(
                <p>
                  Kementerian Pendidikan dan Kebudayaan (Kemendikbud) meraih penghargaan Indonesia Government Procurement Awards dari Lembaga Kebijakan Pengadaan Barang/Jasa Pemerintah (LKPP)
                  kategori Kementerian/Lembaga/Pemerintah Daerah dengan Inovasi Pengadaan yang Mendukung Transparansi Belanja Pengadaan. Penghargaan ini diterima langsung oleh Menteri Pendidikan dan Kebudayaan (Mendikbud),
                  Nadiem Anwar Makarim, pada acara Rapat Koordinasi Nasional Pengadaan Barang/Jasa (Rakornas PBJ) 2020 di Hotel Grand Savero, Kota Bogor, Jawa Barat, Rabu (18/11/2020).
                  {' '}
                </p>
                )}
            />
          </Col>
          <Col lg={12} className="mb-5">
            <ArticleCard
              thumbnailImg="./assets/article-2.jpeg"
              title="Sinergi Kebijakan Pengadaan Barang dan Jasa Satuan Pendidikan Regional I"
              url="https://siplah.kemendikdasmen.go.id/index.php/linimasa/entry/sinergi-kebijakan-pengadaan-barang-dan-jasa-satuan-pendidikan-regional-i"
              date="10 Nov 2020"
              shortDescription={
                <p>SIPLah adalah sebuah inovasi dalam pengadaan barang/jasa Satuan Pendidikan, selain meningkatkan transparansi juga memudahkan bagi Satuan Pendidikan (Satdik) dalam melakukan administrasi serta pelaporan. Begitu pula UMKM akan semakin mudah dalam turut serta hadir sebagai penyedia barang dan jasa di SIPLah. Regional I Selasa, 10 November 2020 08.00-12.00 WIB</p>
                }
            />
          </Col>
        </Row>
      </Container>
    </section>
  </div>
)

LearnSiplah.propTypes = {

}

export default LearnSiplah
